// export const informCustomEvent = (eventName: string, data = {}) => {
export const informCustomEvent = (eventName: string) => {
  if ((window as any).gtag) {
    console.log(eventName)
    typeof window !== 'undefined' &&
      ((window as any).gtag ? (window as any).gtag('event', eventName) : '')
  }
  return null
}

export const sendGoogleAdsConversion = (sendToCode: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    ;(window as any).gtag('event', 'conversion', {
      send_to: sendToCode,
    })
  }
}
